module.exports = __webpack_public_path__ + "img/shopping_application_4-1.43ac3493.jpg";